module.exports = __webpack_public_path__ + "img/welding-8.fb5188dd.jpg";